import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { shift_pressed } from '@frontend/keypress';
import convert_partstudio_svg from '../../../assets/img/SVG_icons/Top/reference_operation/convert_ref_to_phi.svg';
import { img } from '@phi/components';
import { SessionType } from '@phi/authentication/frontend';
import { start_convert_reference_to_phi } from '@frontend/ui_display';
import ConvertPartstudioTooltip from './ConvertPartstudioTooltip';

export const ConvertPartstudioIcon = convert_partstudio_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        session_type: { required: true, type: null as any as PropType<Set<SessionType>> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Convert reference to Phi model';
        },

        disabled() {
            return !this.state.loaded
                || (
                    this.state.framework !== 'onshape'
                    && !this.session_type.has('onshape')
                )
                || !this.state.showing_reference_partstudio_models
                || this.selected_objects > 0;
        },

        selected_objects() {
            return this.state.selected_edges_count
                + this.state.selected_faces_count
                + this.state.selected_vertices_count;
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                start_convert_reference_to_phi(shift_pressed());
        },

        onLongClick() {
            if (this.disabled)
                return;
            else
                start_convert_reference_to_phi(true);
        },
    },

    render() {
        return h(BarButton, {
            id: 'convert-ref-to-phi-button',
            long: true,
            onClick: this.onClick,
            onLongClick: this.onLongClick,
            disabled: this.disabled,
            active: this.state.converting_reference_to_phi,
            selected: this.state.tut_stage === 13,
            tippy: 'right',
            help: 'convert_ref_to_phi',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(convert_partstudio_svg, this.alt),
            tooltip: ConvertPartstudioTooltip,
        });
    },
});
